module.exports = __webpack_public_path__ + "img/pasteure-1.9497d688.jpg";